import type { ReactNode } from 'react';

export interface BulletListData {
  items: ReactNode[];
  iconImg?: string;
}

export interface BulletListProps extends BulletListData {}
